module.exports = __webpack_public_path__ + "static/media/play-circle.d18ac86d.svg";